import { useContext } from "react"
import FormContext from "../FormContextAdmin"

const useGetFormContext = () => {
    return useContext(FormContext)
}

export default useGetFormContext